<template>
  <div class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="flex flex-col items-center justify-center align-middle min-h-screen pt-4 px-4 pb-20 text-center">
      <div class="fixed inset-0 bg-gray-400 bg-opacity-50 transition-opacity" aria-hidden="true" />
      <div class="loader">
        <div class="dot dot1">
          <i />
        </div>
        <div class="dot dot2">
          <i />
        </div>
        <div class="dot dot3">
          <i />
        </div>
        <div class="dot dot4">
          <i />
        </div>
        <div class="dot dot5">
          <i />
        </div>
        <div class="dot dot6">
          <i />
        </div>
        <div class="dot dot7">
          <i />
        </div>
        <div class="dot dot8">
          <i />
        </div>
        <div class="dot dot9">
          <i />
        </div>
      </div>
      <span class="font-bold block text-gray-800 mt-5">{{ $store.state.ui.loadingText }}</span>
    </div>
  </div>
</template>

<script></script>

<style>
.loader {
  position: relative;
  display: flex;
  justify-content: center;
  align-content: center;
  width: 120px;
  height: 20px;
}

.dot {
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;
  align-content: center;
  margin: 0 5px;
  height: 20px;
  width: 2px;
}

.dot:first-of-type {
  margin-left: 0;
}

.dot:last-of-type {
  margin-right: 0;
}

.dot::before,
.dot::after {
  content: "";
  position: absolute;
  bottom: -5px;
  display: block;
  width: 4px;
  height: 4px;
  background: #0d8aba;
  border-radius: 4px;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.15);
  animation: helix 0.5s ease-in-out infinite;
}

.dot::after {
  bottom: 100%;
  animation: helix-reversed 0.5s ease-in-out infinite;
}

.dot i {
  position: absolute;
  z-index: 25;
  align-self: center;
  width: 2px;
  height: 10px;
  background: #0d8aba;
  animation: helix-bar 1.25s ease-in-out infinite;
}

.dot2::before,
.dot2::after,
.dot2 i {
  animation-delay: 0.05s;
}

.dot3::before,
.dot3::after,
.dot3 i {
  animation-delay: 0.1s;
}

.dot4::before,
.dot4::after,
.dot4 i {
  animation-delay: 0.15s;
}

.dot5::before,
.dot5::after,
.dot5 i {
  animation-delay: 0.2s;
}

.dot6::before,
.dot6::after,
.dot6 i {
  animation-delay: 0.25s;
}

.dot7::before,
.dot7::after,
.dot7 i {
  animation-delay: 0.3s;
}

.dot8::before,
.dot8::after,
.dot8 i {
  animation-delay: 0.35s;
}

.dot9::before,
.dot9::after,
.dot9 i {
  animation-delay: 0.4s;
}

@keyframes helix {
  0% {
    width: 5px;
    height: 5px;
    bottom: -5px;
    z-index: 10;
  }
  25% {
    width: 2px;
    height: 2px;
  }
  50% {
    width: 5px;
    height: 5px;
    bottom: 100%;
    z-index: 20;
  }
  75% {
    width: 8px;
    height: 8px;
  }
  100% {
    width: 5px;
    height: 5px;
    bottom: -5px;
  }
}

@keyframes helix-reversed {
  0% {
    width: 5px;
    height: 5px;
    bottom: 100%;
    z-index: 20;
  }
  25% {
    width: 8px;
    height: 8px;
  }
  50% {
    width: 5px;
    height: 5px;
    bottom: -5px;
    z-index: 10;
  }
  75% {
    width: 2px;
    height: 2px;
  }
  100% {
    width: 5px;
    height: 5px;
    bottom: 100%;
  }
}

@keyframes helix-bar {
  0% {
    height: 15px;
  }
  25% {
    height: 8px;
  }
  50% {
    height: 15px;
  }
  75% {
    height: 8px;
  }
  100% {
    height: 15px;
  }
}

.lds-roller {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}
.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #2c67ab;
  margin: -4px 0 0 -4px;
}
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 63px;
  left: 63px;
}
.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 68px;
  left: 56px;
}
.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 71px;
  left: 48px;
}
.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}
.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 71px;
  left: 32px;
}
.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 68px;
  left: 24px;
}
.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 63px;
  left: 17px;
}
.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 56px;
  left: 12px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
